import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

export const query = gql`
  query Packages {
    dealPackages {
      results {
        uuid
        name
      }
    }
  }
`

export const toString = query.loc.source.body

export const dealPackagesKey = getQueryNames(query)[0]

export default query
